import { createContext, useContext } from 'react';
export const PaymentNoticesContext = createContext(null);
export const usePaymentNotices = () => useContext(PaymentNoticesContext);
